(function () {

  angular.module('DataSourceProvider', [])

    .constant('SortDirection', {
      Ascending: 'ASC',
      Descending: 'DESC'
    })

    .factory('DataSourceRequest', function () {
      return function (displayName, columns, records) {

        this.displayName = displayName; // string, notblank
        this.columns = columns;         // array of DataSourceColumnRequest objects, notnull
        this.records = records;         // array of arrays of strings, notnull

        return this;
      };
    })

    .factory('DataSourceColumnRequest', function () {
      return function (id, name, displayName, visible, metadata, sortIndex, sortDirection) {

        this.id = id;                       // integer, nullable
        this.name = name;                   // string, notblank
        this.displayName = displayName;     // string, notblank
        this.visible = visible;             // boolean
        this.metadata = metadata;           // boolean
        this.sortIndex = sortIndex;         // integer, nullable
        this.sortDirection = sortDirection; // string, nullable, property of SortDirection

        return this;
      };
    })

    .service('DataSourceService', function ($http, $log, $q, TenantListService) {

      /**
       * @param {string} dataSourceId The ID of the data source to retrieve.
       * @returns {Promise<DataSourceResponse>} A promise that resolves to the data source with the given ID.
       */
      this.getDataSource = function (dataSourceId) {
        const deferred = $q.defer();
        const url = `${TenantListService.currentTenant.info._links['px:dataSources'].href}/${dataSourceId}`;
        $http.get(url)
          .then(function (response) {
            deferred.resolve(response.data);
          })
          .catch(function (error) {
            $log.error('Failed to retrieve DataSource with ID=' + dataSourceId);
            deferred.reject(error.status);
          });
        return deferred.promise;
      };

      /**
       * @param {DataSourceRequest} dataSourceRequest The data source to create.
       * @returns {Promise<DataSourceResponse>} A promise that resolves to the created data source.
       */
      this.createDataSource = function (dataSourceRequest) {
        const deferred = $q.defer();
        const url = TenantListService.currentTenant.info._links['px:dataSources'].href;
        $http.post(url, dataSourceRequest)
          .then(function (response) {
            deferred.resolve(response.data);
          })
          .catch(function (error) {
            $log.error('Failed to create data source.');
            deferred.reject(error.status);
          });
        return deferred.promise;
      };

      /**
       * @param {string} dataSourceId The ID of the data source to update.
       * @param {DataSourceRequest} dataSourceRequest The data source to update.
       * @returns {Promise<DataSourceResponse>} A promise that resolves to the updated data source.
       */
      this.updateDataSource = function (dataSourceId, dataSourceRequest) {
        const deferred = $q.defer();
        const url = `${TenantListService.currentTenant.info._links['px:dataSources'].href}/${dataSourceId}`;
        $http.put(url, dataSourceRequest)
          .then(function (response) {
            deferred.resolve(response.data);
          })
          .catch(function (error) {
            $log.error('Failed to update data source with ID=' + dataSourceId);
            deferred.reject(error.status);
          });
        return deferred.promise;
      };

      /**
       * @param {string} dataSourceId The ID of the data source to delete.
       * @returns {Promise} A promise that resolves when the data source is deleted.
       */
      this.deleteDataSource = function (dataSourceId) {
        const deferred = $q.defer();
        const url = `${TenantListService.currentTenant.info._links['px:dataSources'].href}/${dataSourceId}`;
        $http.delete(url)
          .then(function (response) {
            deferred.resolve();
          })
          .catch(function (error) {
            $log.error('Failed to delete data source with ID=' + dataSourceId);
            deferred.reject(error.status);
          });
        return deferred.promise;
      };

      /**
       * @param {string} url The URL to retrieve the data source records from.
       * @returns {Promise<DataSourceRecordResponse[]>} A promise that resolves to a list of data source records.
       */
      this.getDataSourceRecords = function (url, page = 0, pageSize = 10000) {
        const deferred = $q.defer();
        url += `?page=${page}&pageSize=${pageSize}`;
        $http.get(url)
          .then(function (response) {
            deferred.resolve(response.data._embedded['px:dataRecords']);
          })
          .catch(function (error) {
            $log.error('Failed to retrieve data source records.');
            deferred.reject(error.status);
          });
        return deferred.promise;
      };

      return this;
    });

})();
